<div id="payfrequencyJuncture" class="container">
    <div class="row">
        <div class="col-12 p-0" *ngIf="!this.FlagService.flagServiceObject[7]['conditionsJunctureFlag']">
            <div class="component-header __indicator">
                <h3 class="label m-0">{{ 'junctures.payFrequency.header' | translate }}</h3>
            </div>
        </div>

        <div class="col-12 px-0" *ngIf="!this.FlagService.flagServiceObject[7]['conditionsJunctureFlag']">
            <ul>
              <li class="px-2" id="{{option.value}}" *ngFor="let option of mockedData" (click)="sendUserdata($event)">
                    <span class="month fw-bold">{{ option.month }}</span>
                    <fa-icon class="text-center me-3" [icon]="faCalendar"></fa-icon>
                    <div class="text">
                        <span class="label">{{ option.label }} - {{ option.amount | number:'1.0-0':'hu-HU' }} Ft</span>
                    </div>
                </li>
            </ul>
        </div>

    </div>

    <div class="row feedback-module" *ngIf="this.FlagService.flagServiceObject[7]['conditionsJunctureFlag']" (click)="payfrequencyJunctureClick()">
        <div class="d-flex p-0">
            <a class="w-100">
                <fa-icon class="text-center ms-3 me-3" [icon]="faCalendar"></fa-icon>
                <div class="text">
                    <span class="top">{{ this._feedbackLabel }}</span>
                </div>
            </a>

            <div class="flex-shrink-1">
                <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
            </div>
        </div>
    </div>
</div>
